// extracted by mini-css-extract-plugin
export default {"selected-recipient-section":"recipients_selected-recipient-section__A5Fre"};